import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      isActive: false,
      showDismissAnimation: false,
    };
  },
  methods: {
    toggleBaseModal(status: boolean) {
      if (!status) {
        this.showDismissAnimation = true;
        setTimeout(() => {
          this.isActive = status;
          document.body.style.overflow = this.isActive ? "hidden" : "visible";
          this.showDismissAnimation = false;
        }, 200);
      } else {
        this.isActive = status;
        document.body.style.overflow = this.isActive ? "hidden" : "visible";
      }
    },
  },
});
